import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import X46MK2InteriorConfiguratorImage from './X46MK2InteriorConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import RadioGroup from './../RadioGroup'
import MaterialSelector from './../MaterialSelector'
import { withTranslation, Trans } from 'react-i18next'
import { interiorView04ImageOptions } from './views/InteriorView04'

class X46MK2AftCabin extends Component {
  constructor (props) {
    super(props)
    this.handleOptionsChange = this.handleOptionsChange.bind(this)
    this.handleFabricChange = this.handleFabricChange.bind(this)
  }

  handleOptionsChange (newValue) {
    const configuration = this.props.configuration
    configuration.PortAftCabinOptions = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleFabricChange (newValue) {
    const configuration = this.props.configuration
    configuration.FabricCabins = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    const image = (
      <X46MK2InteriorConfiguratorImage
        boat='X46MK2'
        configuration={this.props.configuration}
        options={interiorView04ImageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Port aft cabin' />
          </h1>

          <p>
            <Trans defaults='Standard of the X4<sup>6</sup> is double berth in both aft cabins.' />
          </p>
          <p>
            <Trans defaults='For extra storage, upper shelves in both aft cabins is an option.' />
          </p>
          <p>
            <Trans defaults='On this image, the cabin is shown with ambient lighting fitted in hull deck joint.' />
          </p>
          <h2>
            <Trans defaults='Furniture' />
          </h2>
          <RadioGroup
            options={this.props.portAftCabinOptions}
            value={this.props.configuration.PortAftCabinOptions}
            onChange={this.handleOptionsChange}
          />

          <h2>
            <Trans defaults='Fabric cabins' />
          </h2>
          <MaterialSelector
            options={this.props.fabricCabinsOptions || this.props.fabricOptions}
            label={this.props.configuration.FabricCabins.label}
            value={this.props.configuration.FabricCabins}
            onChange={this.handleFabricChange}
          />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2AftCabin)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2AftCabin.js